var _style, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _path4, _polygon, _polygon2, _g, _rect6, _g2, _rect7, _rect8, _rect9, _polygon3, _g3, _polygon4, _polygon5, _polygon6, _rect10, _path5, _line, _line2, _circle, _circle2, _path6, _circle3, _circle4, _circle5, _line3, _path7, _path8, _path9, _path10, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _g4, _polygon13, _g5, _polygon14, _polygon15, _polygon16, _g6, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _path11, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _polygon23, _rect11, _rect12, _rect13, _polygon24, _polygon25, _polyline, _line4, _line5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g7, _polyline2, _path25, _path26, _line6, _path27, _polyline3, _path28, _line7, _path29, _polyline4, _line8, _polyline5, _line9, _circle6, _path30, _path31, _path32, _path33, _path34, _path35, _circle7, _path36, _path37, _path38, _path39, _path40, _path41, _line10, _path42, _path43, _g8, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g9, _polyline6, _path57, _path58, _line11, _path59, _polyline7, _path60, _line12, _path61, _polyline8, _line13, _polyline9, _line14, _circle8, _path62, _path63, _path64, _path65, _circle9, _path66, _circle10, _circle11, _g10, _polygon26, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _polyline10, _path89, _path90, _line15, _polyline11, _path91, _line16, _polyline12, _line17, _polyline13, _line18, _circle12, _path92, _path93, _path94, _g11, _g12, _circle13, _circle14, _g13, _g14, _circle15, _circle16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.3 28.3",
    style: {
      enableBackground: "new 0 0 28.3 28.3"
    },
    xmlSpace: "preserve",
    className: "note",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.note .st0{fill:#DADADA;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n\t.note .st1{fill:#FFFFFF;}\n\t.note .st2{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.note .st3{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.note .st4{fill:none;stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n\t.note .st5{fill:#141414;}\n\t.note .st6{fill:#DADADA;}\n\t.note .st7{fill:url(#SVGID_1_);stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.note .st8{fill:#DADADA;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.note .st9{fill:#E6007E;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.note.st10{fill:url(#SVGID_00000099626518391106878350000017400016623481915572_);}\n\t\n\t\t.note .st11{fill:url(#SVGID_00000021816022445816207590000008227528058688582312_);stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t\n\t\t.note .st12{fill:url(#SVGID_00000085965535660780588040000016158677227692758453_);stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t\n\t\t.note .st13{fill:url(#SVGID_00000039124907765725918820000008444689196031069111_);stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.note .st14{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.note .st15{fill:none;stroke:#E6007E;stroke-miterlimit:10;}\n\t.note .st16{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.note .st17{fill:none;stroke:#E52729;stroke-miterlimit:10;}\n\t .note.note.st18{fill:#E52729;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1054.3,1627.3l-1.9-0.9l-3.7,2l-119.3-68.3c0,0-1.1,0.9-1.3,1.6c-0.2,0.7,0,33.3,0,33.3l-0.1,0.5 c0,0.9,0.5,0.9,1.3,1.3l118.8,68.4c0.3,0.2,0.6,0.2,0.9,0l4.5-2.3l0.9-0.5l0-34.9c0-0.2-0.1-0.4-0.3-0.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1180.5,1448.7v-27.7c0-0.2,0.2-0.3,0.4-0.2l120.2,69.8v28.3l-119.9-69 C-1180.2,1449.6-1180.5,1449.2-1180.5,1448.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1180.5,1448.5v-27.7c0-0.2,0.2-0.3,0.4-0.2l120.2,69.8v28.3l-119.9-69 C-1180.3,1449.5-1180.5,1449-1180.5,1448.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -106.4,
    y: 2212.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2360.5481 2275.2725)",
    className: "st2",
    width: 298,
    height: 211.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9,
    y: 2063.9,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2214.8042 2129.0161)",
    className: "st2",
    width: 6,
    height: 216
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 2312.6,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2460.978 2375.8423)",
    className: "st2",
    width: 53,
    height: 211.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 2095,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2243.3884 2157.1216)",
    className: "st2",
    width: 43,
    height: 210.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -39.2,
    y: 2201.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2349.6709 2264.1497)",
    className: "st2",
    width: 164,
    height: 211.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1060,1478.5l-110.3-64.1c-0.4-0.3-0.4-0.9,0-1.1l90.1-51.3c0.2-0.1,112.1,63.6,111.7,63.9 C-977.5,1431-1059.8,1478.6-1060,1478.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-666.3,2226.9 -818.3,2139.2 -661.1,2048.4 -509.1,2136.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-667.4,2219.8 -806,2139.8 -676.9,2065.3 -538.4,2145.3 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -670.7,
    cy: 2178.1,
    rx: 29.7,
    ry: 17.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -670.7,
    cy: 2178.1,
    rx: 27.9,
    ry: 16.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -673.4,
    cy: 2107.1,
    rx: 29.7,
    ry: 17.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -673.4,
    cy: 2107.1,
    rx: 26.4,
    ry: 15.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -610.7,
    cy: 2143.4,
    rx: 34.8,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -610.7,
    cy: 2143.4,
    rx: 31.9,
    ry: 18.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -733.5,
    cy: 2141.8,
    rx: 34.8,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: -733.5,
    cy: 2141.8,
    rx: 32.1,
    ry: 18.6
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 256.9,
    y: 2079.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2431.8025 1912.0144)",
    className: "st2",
    width: 6,
    height: 185
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "349.6,2427.9 349.6,2168.9 169.7,2168.9 169.7,2444.9 180,2444.9 180,2466.9 324,2466.9 324,2427.9  "
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 285.4,
    y: 2227.9,
    className: "st2",
    width: 7.1,
    height: 161
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 253.6,
    y: 2227.9,
    className: "st2",
    width: 7.1,
    height: 161
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 221.8,
    y: 2227.9,
    className: "st2",
    width: 7.1,
    height: 161
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-663.1,2235.2 -663.1,2229.2 -510.8,2141.2 -510.8,2147.2 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-511.7,2400.8 -511.7,2141.8 -662,2228.5 -662,2487.5 -651.7,2481.6 -651.7,2520.6 -533.1,2452.1  -533.1,2413.1  "
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-559.9,2389.6 -565.9,2393.1 -565.9,2232.1 -559.9,2228.6 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-586.8,2405.1 -592.8,2408.6 -592.8,2247.6 -586.8,2244.1 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-613.6,2420.6 -619.6,2424.1 -619.6,2263.1 -613.6,2259.6 "
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -26.1,
    y: 2256.9,
    className: "st2",
    width: 138,
    height: 98
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.6,2245.9H-50.8c-1.8,0-3.3-1.5-3.3-3.3v-2.4c0-1.8,1.5-3.3,3.3-3.3h187.4c1.8,0,3.3,1.5,3.3,3.3v2.4 C139.9,2244.4,138.4,2245.9,136.6,2245.9z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 21.2,
    y1: 2196.2,
    x2: 64.3,
    y2: 2196.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 64.5,
    y1: 2204.3,
    x2: 20.9,
    y2: 2204.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -35.9,
    cy: 2200.3,
    r: 9.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -11.6,
    cy: 2200.3,
    r: 9.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.2,2200.2c0,1.5-0.3,2.9-0.9,4.1c-1.5,3.2-4.7,5.3-8.5,5.4c-5.2,0-9.5-4.2-9.5-9.4c0-5.2,4.2-9.5,9.4-9.5 c3.8,0,7,2.2,8.6,5.4C21.8,2197.4,22.1,2198.8,22.2,2200.2z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 73,
    cy: 2200.3,
    r: 9.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 97.3,
    cy: 2200.3,
    r: 9.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 121.6,
    cy: 2200.3,
    r: 9.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -1180.5,
    y1: 1418.5,
    x2: -1180.5,
    y2: 1414.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1060,1488.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1082.6,1595.3l-76.7-44.3c-0.3-0.2-0.5-0.5-0.5-0.9V1488c0-0.8,0.8-1.2,1.5-0.9l76.7,44.3 c0.3,0.2,0.5,0.5,0.5,0.9v62.2C-1081.1,1595.2-1082,1595.7-1082.6,1595.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1081.2,1593.7l-76.2-44c-0.3-0.2-0.5-0.5-0.5-0.9V1488"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1701.3,757.1l-156.6-90.4c-1.2-0.7-1.2-2.4,0-3.1l151.6-86.8c2.2-1.2,4.8-1.2,6.9,0l155.2,89.6 c2,1.2,2,4.1,0,5.3l-149.3,85.5C1706.7,758.6,1703.7,758.5,1701.3,757.1z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1543.7,942.8 1544.2,667 1706.2,760.6 1705.7,1036.8 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1543.7,674.8 1544.1,667 1706.2,760.6 1705.7,767.8 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1544.1,943 1544.1,890 1706.2,983.6 1706.2,1036.6 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1545,720.5 1545,677.5 1706.2,770.6 1706.2,813.6 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1544.4,887.2 1544.4,723.2 1706.2,816.6 1706.2,980.6 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1704.1,747.3 1562,665.3 1686.8,593.3 1828.8,675.3 "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1695.3,
    cy: 706.4,
    rx: 29.7,
    ry: 17.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1692.6,
    cy: 635.4,
    rx: 29.7,
    ry: 17.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1755.3,
    cy: 671.7,
    rx: 34.8,
    ry: 20.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 1632.5,
    cy: 670.1,
    rx: 34.8,
    ry: 20.1
  }))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1706.7,767.8 1706.4,759.8 1862.7,669.6 1862.7,679.8 "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1861.7,929.2 1861.7,670.2 1706,760.1 1706,1036.1 1713.7,1031.8 1713.7,1053.8 1839.6,980.9  1839.6,941.9  "
  }))), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1812.3,918.7 1806.1,922.3 1806.1,761.3 1812.3,757.7 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1784.8,934.6 1778.6,938.2 1778.6,777.2 1784.8,773.6 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1757.2,950.5 1751.1,954.1 1751.1,793.1 1757.2,789.5 "
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1674,930 1575.5,873.1 1575.5,775.1 1674,832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1673.7,923.8 1579.5,869.1 1579.7,777.8 1673.7,831.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1692,829.4l-134.6-77.7c-1.1-0.6-2-2.3-2-3.8v-0.7c0-1.5,0.9-2.1,2-1.5l134.6,77.7c1.1,0.6,2,2.3,2,3.8v0.7 C1694,829.4,1693.1,830,1692,829.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -145.5791 878.1533)",
    className: "st2",
    cx: 1565.8,
    cy: 710.7,
    rx: 5.8,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -148.3926 888.6534)",
    className: "st2",
    cx: 1584,
    cy: 721.2,
    rx: 5.8,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -151.206 899.1536)",
    className: "st2",
    cx: 1602.2,
    cy: 731.7,
    rx: 5.8,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -158.1727 925.1538)",
    className: "st2",
    cx: 1647.3,
    cy: 757.7,
    rx: 5.8,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -160.9862 935.6539)",
    className: "st2",
    cx: 1665.4,
    cy: 768.2,
    rx: 5.8,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -163.7996 946.1541)",
    className: "st2",
    cx: 1683.6,
    cy: 778.7,
    rx: 5.8,
    ry: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1647.4,761.3 1602.4,735.3 1602.4,728.3 1647.4,754.3  "
  })))), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-818.9,2439 -818.9,2141 -666.5,2228.9 -666.5,2526.9 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-819,2146.9 -819,2140.9 -666.7,2228.8 -666.7,2234.8 "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-819,2416.9 -819,2363.9 -666.7,2451.8 -666.7,2504.8 "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-818.1,2194.4 -818.1,2151.4 -666.4,2239 -666.4,2282 "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-818.7,2361.1 -818.7,2197.1 -667,2284.7 -667,2448.7 "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-692.5,2401.9 -791,2345.1 -791,2247.1 -692.5,2303.9 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-674.5,2301.3l-134.6-77.7c-1.1-0.6-2-2.3-2-3.8v-0.7c0-1.5,0.9-2.1,2-1.5l134.6,77.7c1.1,0.6,2,2.3,2,3.8v0.7 C-672.5,2301.3-673.4,2302-674.5,2301.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -1198.5978 -107.9739)",
    className: "st2",
    cx: -800.8,
    cy: 2182.6,
    rx: 5.8,
    ry: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -1201.4113 -97.4738)",
    className: "st2",
    cx: -782.6,
    cy: 2193.1,
    rx: 5.8,
    ry: 10
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -1204.2247 -86.9737)",
    className: "st2",
    cx: -764.4,
    cy: 2203.6,
    rx: 5.8,
    ry: 10
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -1211.1914 -60.9734)",
    className: "st2",
    cx: -719.4,
    cy: 2229.6,
    rx: 5.8,
    ry: 10
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -1214.0049 -50.4733)",
    className: "st2",
    cx: -701.2,
    cy: 2240.1,
    rx: 5.8,
    ry: 10
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -1216.8184 -39.9732)",
    className: "st2",
    cx: -683,
    cy: 2250.6,
    rx: 5.8,
    ry: 10
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "-719.2,2233.2 -764.3,2207.2 -764.3,2200.2 -719.2,2226.2 "
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 335.4,
    y: 2388.9,
    className: "st2",
    width: 14,
    height: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2388.9,
    className: "st2",
    width: 10.5,
    height: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2221.9,
    className: "st2",
    width: 10,
    height: 3
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1705.6,983 1716.9,976.5 1716.9,973.5 1705.6,980 "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1705.6,816 1716.9,809.5 1716.9,806.5 1705.6,813 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "1550.7,947.3 1550.7,956.8 1550.6,960.3 1712.6,1053.3 "
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1716.7,
    y1: 1029.8,
    x2: 1716.7,
    y2: 762.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 179.4,
    y1: 2445.4,
    x2: 179.4,
    y2: 2175.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-990.9,1588.4L-990.9,1588.4c-1.4,0.8-3.1-0.2-3.1-1.8v-102.2c0-0.7,0.4-1.4,1-1.8l0,0 c1.4-0.8,3.1,0.2,3.1,1.8v102.2C-989.9,1587.3-990.2,1588-990.9,1588.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1009,1598.9L-1009,1598.9c-1.4,0.8-3.1-0.2-3.1-1.8v-102.2c0-0.7,0.4-1.4,1-1.8l0,0c1.4-0.8,3.1,0.2,3.1,1.8 v102.2C-1008,1597.9-1008.4,1598.6-1009,1598.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1027.1,1609.5L-1027.1,1609.5c-1.4,0.8-3.1-0.2-3.1-1.8v-102.2c0-0.7,0.4-1.4,1-1.8l0,0 c1.4-0.8,3.1,0.2,3.1,1.8v102.2C-1026.1,1608.5-1026.5,1609.1-1027.1,1609.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-965.1,1575.4l7.6-4.4c0.1,0,0.1-0.1,0.1-0.1v-1.6c0-0.1-0.1-0.2-0.3-0.1l-7.6,4.4c-0.1,0-0.1,0.1-0.1,0.1v1.6 C-965.4,1575.4-965.3,1575.4-965.1,1575.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-964.8,1470.5l7.4-4.3v-2l-7.8,4.5c-0.1,0.1-0.2,0.2-0.2,0.4v1C-965.4,1470.4-965.1,1470.6-964.8,1470.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-957.3,1431.1l-54.9,31.7l-47,27.4c-0.4,0.2-0.9,0.2-1.3,0l-119.6-69.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1054.7,1625.5l-4.8,2.7c-0.4,0.2-0.8,0.2-1.2,0l-119.1-68.6c-0.3-0.1-0.7-0.4-0.8-0.9c0-0.1,0,0.1,0,0 l0.2-107.5l120.1,69.4c0.2,0.1,0.4,0.1,0.6,0l5.5-3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1054,1662.3l-5.5,2.8c-0.3,0.2-0.6,0.1-0.9,0l-118.8-68.4c-0.8-0.5-1.3-1.3-1.3-2.3v-32.7 c0-0.3,0.3-0.5,0.6-0.3l119.3,68.7c0.4,0.2,0.9,0.2,1.2,0l5.1-2.9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1180.5,1558.8c0.1,0.5,0.5,0.7,0.8,0.9l119.1,68.6c0.4,0.2,0.8,0.2,1.2,0l5.1-2.9c0.1-0.1,0.2-0.2,0.2-0.3 l0.1-107c0-0.2-0.1-0.5-0.3-0.6l-1.4-0.8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1179.7,1559.6l119.1,68.6c0.4,0.2,0.8,0.2,1.2,0l5.1-2.9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1056.2,1486.1l2.1,1.2l0,28.1c0,0.1-0.1,0.2-0.2,0.3l-5.1,3c-0.4,0.2-0.9,0.2-1.2,0l-119.1-68.8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1056,1626.3l1.5,0.7c0.2,0.1,0.3,0.3,0.3,0.4l0,34.9l-0.9,0.5l-4.5,2.3c-0.3,0.2-0.6,0.1-0.9,0l-118.8-68.4 c-0.8-0.5-1.3-1.3-1.3-2.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-1056,1626.3l1.5,0.7c0.2,0.1,0.3,0.3,0.3,0.4l0,34.9l-0.9,0.5l-4.5,2.3c-0.3,0.2-0.6,0.1-0.9,0l-114.1-65.6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1067.1,1535.4l-109.4-63.5c-1.3-0.7,0-5.2,3.3-5.9l109.4,63.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1062.9,1531c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5c-0.7,0.4-1.4,0.4-1.9,0.1 c-0.4-0.3-0.6-0.8-0.6-1.5c0-1.5,1.1-3.4,2.4-4.2c0.5-0.3,1-0.4,1.4-0.3C-1063.3,1529.5-1062.9,1530.1-1062.9,1531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1064,1529.4c0.6,0.1,1.1,0.7,1.1,1.7c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5 c-0.7,0.4-1.4,0.4-1.9,0.1"
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "-1158.8,1474.4 -1155,1472.2 -1145.6,1477.6 -1145.7,1481.8 "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-1179.7,1412.4l98.6-55.8c2.1-1.2,4.6-1.2,6.7,0l116.2,65.9c1,0.6,1,2,0,2.5l-100.5,57.9 c-0.8,0.5-1.8,0.5-2.6,0.1h0l-117-67.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-957.3,1423.3l0,4.4c0,0.8-0.4,1.6-1.2,2l-53.8,31.1l-46.6,26.8c-0.7,0.4-1.6,0.4-2.3,0l-117.5-68.1l-1.4-0.8 c-0.3-0.2-0.4-0.4-0.4-0.8v-4.1"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -1060.3,
    y1: 1517.6,
    x2: -1060.3,
    y2: 1491.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1179.8,1450.1"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "-1060,1631.5 -1060,1645.3 -1059.9,1662.4 "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-957.3,1594.2c0,0.8-0.6,1.1-1.4,1.5l-6.5,3.9c-0.4,0.2-0.6,0.7-0.6,1.1l0,24.9c0,0.2-0.1,0.4-0.3,0.6 l-87.4,50.4c-0.3,0.2-0.7,0.2-1,0l-119.4-69.7c-0.4-0.3-0.7-0.7-0.7-1.3l0-6.1l-4.8-2.6c-0.7-0.4-1.2-1.1-1.2-2l0-33.3 c0-0.4,0.2-0.7,0.5-1l0.8-0.7l-0.5-0.3c-0.4-0.2-0.8-0.8-0.8-1.3l0-0.4l0-106.5c0-0.4,0.2-0.7,0.5-0.9l0.8-0.6l-0.4-0.2 c-0.5-0.3-0.9-0.8-0.9-1.4l0-27.5c0-0.1,0.1-0.2,0.2-0.3l1.7-1.1l-1.4-0.8c-0.3-0.2-0.4-0.4-0.4-0.8c0,0,0-4.4,0-4.8 c0-0.4,0.3-0.6,0.7-0.8l98.6-55.8c2.1-1.2,4.6-1.2,6.7,0l116.2,65.9c0,0,0.9,0.5,0.9,0.9"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -1060.3,
    y1: 1484.5,
    x2: -1060.3,
    y2: 1487
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-957.3,1594.2l0-87.7l0-75.2c0-0.2-0.1-0.4-0.3-0.5l-1.6-0.7l0.7-0.4c0.7-0.4,1.2-1.2,1.2-2l0-4.4"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "-1059.9,1522 -1059.9,1572.2 -1060,1626.9 "
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -1145.7,
    y1: 1477.6,
    x2: -1149.6,
    y2: 1479.6
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "-1092.3,1513.2 -1088.5,1511 -1079.1,1516.5 -1079.2,1520.6 "
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -1079.2,
    y1: 1516.4,
    x2: -1083.2,
    y2: 1518.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -1060.4,
    cy: 1483.2,
    r: 1.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-965.8,1626.5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3,2201.4c-1.1,0-2-0.8-2-1.8v-9.5c0-1,0.9-1.8,2-1.8s2,0.8,2,1.8v9.5C99.3,2200.6,98.4,2201.4,97.3,2201.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.9,2140.2c-1-0.6-1.7-1.8-1.7-2.8v-9.5c0-1,0.8-1.4,1.7-0.8s1.7,1.8,1.7,2.8v9.5 C91.6,2140.4,90.8,2140.8,89.9,2140.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1078,1488.8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1082.3,1490.8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1131.9,1605.8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -1202.8,
    cy: 1373.4,
    r: 22.6
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1207.9559 1380.6813)",
    className: "st1",
    style: {
      fontFamily: "'VAGRoundedStd-Bold'",
      fontSize: "28.0583px"
    }
  }, "1"), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-874,1567.4l0-106.9c0,0,0-2.1,2.5-0.7c2.5,1.4,118.1,67.9,118.1,67.9l4.1-2.2l1.7,1.4l-0.3,107.3l-5.1,2.9 c-0.4,0.2-120.2-68.6-120.2-68.6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-874,1567.4l0-106.9c0,0,0-2.1,2.5-0.7c2.5,1.4,118.1,67.9,118.1,67.9l4.1-2.2l1.7,1.4l-0.3,107.3l-5.1,2.9 c-0.4,0.2-120.2-68.6-120.2-68.6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-874,1567.4l0-106.9c0,0,0-2.1,2.5-0.7c2.5,1.4,118.1,67.9,118.1,67.9l4.1-2.2l1.7,1.4l-0.3,107.3l-5.5,3 c-0.4,0.2-119.8-68.7-119.8-68.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-874,1457.6v-27.7c0-0.2,0.2-0.3,0.4-0.2l120.2,69.8v28.3l-119.9-69C-873.8,1458.5-874,1458.1-874,1457.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-874.1,1457.4v-27.7c0-0.2,0.2-0.3,0.4-0.2l120.2,69.8v28.3l-119.9-69 C-873.8,1458.4-874.1,1457.9-874.1,1457.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-753.6,1487.3l-110.3-64.1c-0.4-0.3-0.4-0.9,0-1.1l90.1-51.3c0.2-0.1,112.1,63.6,111.7,63.9 C-671.1,1439.9-753.4,1487.5-753.6,1487.3z"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -874,
    y1: 1427.4,
    x2: -874,
    y2: 1423.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-753.6,1497.2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-776.2,1604.2l-76.7-44.3c-0.3-0.2-0.5-0.5-0.5-0.9v-62.2c0-0.8,0.8-1.2,1.5-0.9l76.7,44.3 c0.3,0.2,0.5,0.5,0.5,0.9v62.2C-774.7,1604.1-775.5,1604.6-776.2,1604.2z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-850.8,1558.3c-0.2-0.1-0.4-0.3-0.4-1.2v-60.4l76.3,43.7l-0.1,61.7L-850.8,1558.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-851,1497.2l75.8,43.4l-0.1,61.1l-75.5-43.6c-0.1,0-0.2-0.1-0.2-1V1497.2 M-851.5,1496.3v60.8c0,0.9,0.2,1.2,0.5,1.4 l76.2,44l0.1-62.3L-851.5,1496.3L-851.5,1496.3z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-684.4,1597.3L-684.4,1597.3c-1.4,0.8-3.1-0.2-3.1-1.8v-102.2c0-0.7,0.4-1.4,1-1.8l0,0 c1.4-0.8,3.1,0.2,3.1,1.8v102.2C-683.4,1596.2-683.8,1596.9-684.4,1597.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-702.6,1607.8L-702.6,1607.8c-1.4,0.8-3.1-0.2-3.1-1.8v-102.2c0-0.7,0.4-1.4,1-1.8l0,0 c1.4-0.8,3.1,0.2,3.1,1.8v102.2C-701.5,1606.8-701.9,1607.5-702.6,1607.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-720.7,1618.4L-720.7,1618.4c-1.4,0.8-3.1-0.2-3.1-1.8v-102.2c0-0.7,0.4-1.4,1-1.8l0,0 c1.4-0.8,3.1,0.2,3.1,1.8v102.2C-719.7,1617.3-720.1,1618-720.7,1618.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-658.7,1584.3l7.6-4.4c0.1,0,0.1-0.1,0.1-0.1v-1.6c0-0.1-0.1-0.2-0.3-0.1l-7.6,4.4c-0.1,0-0.1,0.1-0.1,0.1v1.6 C-659,1584.2-658.8,1584.3-658.7,1584.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-658.3,1479.4l7.4-4.3v-2l-7.8,4.5c-0.1,0.1-0.2,0.2-0.2,0.4v1C-659,1479.3-658.6,1479.5-658.3,1479.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-650.9,1439.9l-54.9,31.7l-47,27.4c-0.4,0.2-0.9,0.2-1.3,0l-119.6-69.5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-748.2,1634.4l-4.8,2.7c-0.4,0.2-0.8,0.2-1.2,0l-119.1-68.6c-0.3-0.1-0.7-0.4-0.8-0.9c0-0.1,0,0.1,0,0 l0.2-107.5l120.1,69.4c0.2,0.1,0.4,0.1,0.6,0l5.5-3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-747.5,1671.2l-5.5,2.8c-0.3,0.2-0.6,0.1-0.9,0l-118.8-68.4c-0.8-0.5-1.3-1.3-1.3-2.3v-32.7 c0-0.3,0.3-0.5,0.6-0.3l119.3,68.7c0.4,0.2,0.9,0.2,1.2,0l5.1-2.9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-874,1567.7c0.1,0.5,0.5,0.7,0.8,0.9l119.1,68.6c0.4,0.2,0.8,0.2,1.2,0l5.1-2.9c0.1-0.1,0.2-0.2,0.2-0.3 l0.1-107c0-0.2-0.1-0.5-0.3-0.6l-1.4-0.8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-749.7,1495l2.1,1.2l0,28.1c0,0.1-0.1,0.2-0.2,0.3l-5.1,3c-0.4,0.2-0.9,0.2-1.2,0l-119.1-68.8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-749.5,1635.2l1.5,0.7c0.2,0.1,0.3,0.3,0.3,0.4l0,34.9l-0.9,0.5l-4.5,2.3c-0.3,0.2-0.6,0.1-0.9,0l-118.8-68.4 c-0.8-0.5-1.3-1.3-1.3-2.3"
  })), /*#__PURE__*/React.createElement("g", null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-756.4,1539.9c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5c-0.7,0.4-1.4,0.4-1.9,0.1 c-0.4-0.3-0.6-0.8-0.6-1.5c0-1.5,1.1-3.4,2.4-4.2c0.5-0.3,1-0.4,1.4-0.3C-756.8,1538.4-756.4,1539-756.4,1539.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -815.2728,
    y1: 1512.8245,
    x2: -811.7134,
    y2: 1506.6593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9201,
    style: {
      stopColor: "#DADADA"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-757.6,1538.3c0.6,0.1,1.1,0.7,1.1,1.7c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5 c-0.7,0.4-1.4,0.4-1.9,0.1l-0.5-0.3l-108.8-63.2c-1.3-0.7,0-5.2,3.3-5.9l109.4,63.5"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-756.4,1539.9c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5c-0.7,0.4-1.4,0.4-1.9,0.1 c-0.4-0.3-0.6-0.8-0.6-1.5c0-1.5,1.1-3.4,2.4-4.2c0.5-0.3,1-0.4,1.4-0.3C-756.8,1538.4-756.4,1539-756.4,1539.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-757.6,1538.3c0.6,0.1,1.1,0.7,1.1,1.7c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5 c-0.7,0.4-1.4,0.4-1.9,0.1l-0.5-0.3l-108.8-63.2c-1.3-0.7,0-5.2,3.3-5.9l109.4,63.5"
  }))), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "-852.3,1483.3 -848.6,1481.1 -839.1,1486.5 -839.2,1490.7 "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-873.3,1421.3l98.6-55.8c2.1-1.2,4.6-1.2,6.7,0l116.2,65.9c1,0.6,1,2,0,2.5l-100.5,57.9 c-0.8,0.5-1.8,0.5-2.6,0.1l0,0l-117-67.9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-650.9,1432.2l0,4.4c0,0.8-0.4,1.6-1.2,2l-53.8,31.1l-46.6,26.8c-0.7,0.4-1.6,0.4-2.3,0l-117.5-68.1l-1.4-0.8 c-0.3-0.2-0.4-0.4-0.4-0.8v-4.1"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -753.9,
    y1: 1526.5,
    x2: -753.9,
    y2: 1500.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-873.4,1459"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "-753.6,1640.4 -753.5,1654.2 -753.4,1671.3 "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-650.9,1603.1c0,0.8-0.6,1.1-1.4,1.5l-6.5,3.9c-0.4,0.2-0.6,0.7-0.6,1.1l0,24.9c0,0.2-0.1,0.4-0.3,0.6 l-87.4,50.4c-0.3,0.2-0.7,0.2-1,0l-119.4-69.7c-0.4-0.3-0.7-0.7-0.7-1.3l0-6.1l-4.8-2.6c-0.7-0.4-1.2-1.1-1.2-2l0-33.3 c0-0.4,0.2-0.7,0.5-1l0.8-0.7l-0.5-0.3c-0.4-0.2-0.8-0.8-0.8-1.3l0-0.4l0-106.5c0-0.4,0.2-0.7,0.5-0.9l0.8-0.6l-0.4-0.2 c-0.5-0.3-0.9-0.8-0.9-1.4l0-27.5c0-0.1,0.1-0.2,0.2-0.3l1.7-1.1l-1.4-0.8c-0.3-0.2-0.4-0.4-0.4-0.8c0,0,0-4.4,0-4.8 c0-0.4,0.3-0.6,0.7-0.8l98.6-55.8c2.1-1.2,4.6-1.2,6.7,0l116.2,65.9c0,0,0.9,0.5,0.9,0.9"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -753.9,
    y1: 1493.4,
    x2: -753.9,
    y2: 1495.9
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-650.9,1603.1l0-87.7l0-75.2c0-0.2-0.1-0.4-0.3-0.5l-1.6-0.7l0.7-0.4c0.7-0.4,1.2-1.2,1.2-2l0-4.4"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "-753.4,1530.9 -753.5,1581.1 -753.6,1635.8 "
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -839.3,
    y1: 1486.5,
    x2: -843.2,
    y2: 1488.5
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "-785.8,1522.1 -782.1,1519.9 -772.7,1525.3 -772.8,1529.5 "
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: -772.8,
    y1: 1525.3,
    x2: -776.7,
    y2: 1527.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -753.9,
    cy: 1492.1,
    r: 1.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-659.3,1635.4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-771.6,1497.7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-775.9,1499.7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-825.5,1614.7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: -896.6,
    cy: 1374.9,
    r: 22.6
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -904.6476 1382.2131)",
    className: "st1",
    style: {
      fontFamily: "'VAGRoundedStd-Bold'",
      fontSize: "28.0583px"
    }
  }, "2"), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-919.7,1595.5l0.4,0.3c8.1-30.4,30-61.3,55.5-75.5c8.9-4.9,17.2-7.3,24.6-7.3c5.1-0.1,29.2,10.2,36.3,16.4 c-6.1-3.5-13.6-4.6-22.1-3.1c-5.6,1-11.6,3.2-17.9,6.7c-25.5,14.1-47.5,45.1-55.6,75.5l7.1,4.3l-9.5,5.6l-15.7,9.3l-5.4-20.9 l-3.8-14.8L-919.7,1595.5z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 14.2,
    cy: 14.2,
    r: 11.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 14.2,
    cy: 14.2,
    r: 9
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13,17.6c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1C13.5,18.6,13,18.2,13,17.6z M13.1,9.3 c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1v5.4c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1V9.3z"
  }))), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "-1179.3,1617.2 -1182.6,1641.3 -1142,1638.7 -1151.1,1633.4 -1112.8,1611.3 -1131.8,1600.3  -1170.1,1622.4 "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M552.1,842.6l0-88.6l0-75.2c0-0.2-0.1-0.4-0.3-0.5l-1.6-0.7l0.7-0.4c0.7-0.4,1.2-1.2,1.2-2l0-4.4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M544.4,822.6l7.6-4.4c0.1,0,0.1-0.1,0.1-0.1v-1.6c0-0.1-0.1-0.2-0.3-0.1l-7.6,4.4c-0.1,0-0.1,0.1-0.1,0.1v1.6 C544.1,822.6,544.3,822.7,544.4,822.6z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M544.7,716l7.4-4.3v-2l-7.8,4.5c-0.1,0.1-0.2,0.2-0.2,0.4v1C544.1,716,544.5,716.2,544.7,716z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540.7,874.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011724491699221657050000015622311891591521980_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.0934,
    y1: 787.1011,
    x2: 455.4667,
    y2: 787.1011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9201,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011724491699221657050000015622311891591521980_)"
    },
    d: "M329.1,806.3l0-106.9c0,0,0-2.1,2.5-0.7 c2.5,1.4,118.1,67.9,118.1,67.9l4.1-2.2l1.7,1.4l-0.3,107.3l-5.1,2.9c-0.4,0.2-120.2-68.6-120.2-68.6"
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M659.4,126.3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.1,696.4v-27.7c0-0.2,0.2-0.3,0.4-0.2l120.2,69.8v28.3l-119.9-69C329.4,697.4,329.1,696.9,329.1,696.4z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329,696.3v-27.7c0-0.2,0.2-0.3,0.4-0.2l120.2,69.8v28.3l-119.9-69C329.3,697.2,329,696.8,329,696.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M449.6,726.2l-110.3-64.1c-0.4-0.3-0.4-0.9,0-1.1l90.1-51.3c0.2-0.1,112.1,63.6,111.7,63.9 C532.1,678.8,449.8,726.3,449.6,726.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M449.6,736.1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M427,843.1l-76.7-44.3c-0.3-0.2-0.5-0.5-0.5-0.9v-62.2c0-0.8,0.8-1.2,1.5-0.9l76.7,44.3 c0.3,0.2,0.5,0.5,0.5,0.9v62.2C428.5,843,427.6,843.5,427,843.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120531885501410696010000007938400117547531912_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.3687,
    y1: 806.574,
    x2: 421.5163,
    y2: 742.8369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07088783,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    style: {
      stopColor: "#D2D2D2",
      stopOpacity: 0.9832
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120531885501410696010000007938400117547531912_)",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: " M427.2,841.6l-75.2-44c-0.2-0.1-0.4-0.4-0.4-0.7l-0.4-60.7c0-0.6,0.6-1,1.2-0.7l75.9,44c0.2,0.1,0.1,0.6,0.1,0.9l-0.1,60.4 C428.4,841.5,427.7,841.9,427.2,841.6z"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M428.4,842.2l-76.2-44.8c-0.3-0.2-0.5-0.5-0.5-0.9v-60.8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M518.7,836.1L518.7,836.1c-1.4,0.8-3.1-0.2-3.1-1.8V732.1c0-0.7,0.4-1.4,1-1.8l0,0c1.4-0.8,3.1,0.2,3.1,1.8 v102.2C519.7,835.1,519.3,835.8,518.7,836.1z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M500.6,846.7L500.6,846.7c-1.4,0.8-3.1-0.2-3.1-1.8V742.7c0-0.7,0.4-1.4,1-1.8l0,0c1.4-0.8,3.1,0.2,3.1,1.8 v102.2C501.6,845.7,501.2,846.3,500.6,846.7z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M482.4,857.2L482.4,857.2c-1.4,0.8-3.1-0.2-3.1-1.8V753.3c0-0.7,0.4-1.4,1-1.8l0,0c1.4-0.8,3.1,0.2,3.1,1.8 v102.2C483.5,856.2,483.1,856.9,482.4,857.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M552.3,678.8l-54.9,31.7l-47,27.4c-0.4,0.2-0.9,0.2-1.3,0l-119.6-69.5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M454.9,873.3l-4.8,2.7c-0.4,0.2-0.8,0.2-1.2,0l-119.1-68.6c-0.3-0.1-0.7-0.4-0.8-0.9c0-0.1,0,0.1,0,0l0.2-107.5 l120.1,69.4c0.2,0.1,0.4,0.1,0.6,0l5.5-3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M455.6,910.1l-5.5,2.8c-0.3,0.2-0.6,0.1-0.9,0l-118.8-68.4c-0.8-0.5-1.3-1.3-1.3-2.3v-32.7 c0-0.3,0.3-0.5,0.6-0.3l119.3,68.7c0.4,0.2,0.9,0.2,1.2,0l5.1-2.9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.1,806.5c0.1,0.5,0.5,0.7,0.8,0.9L449,876c0.4,0.2,0.8,0.2,1.2,0l5.1-2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-107 c0-0.2-0.1-0.5-0.3-0.6l-1.4-0.8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M453.4,733.9l2.1,1.2l0,28.1c0,0.1-0.1,0.2-0.2,0.3l-5.1,3c-0.4,0.2-0.9,0.2-1.2,0l-119.1-68.8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M453.6,874.1l1.5,0.7c0.2,0.1,0.3,0.3,0.3,0.4l0,34.9l-0.9,0.5l-4.5,2.3c-0.3,0.2-0.6,0.1-0.9,0l-118.8-68.4 c-0.8-0.5-1.3-1.3-1.3-2.3"
  })), /*#__PURE__*/React.createElement("g", null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M446.7,778.8c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5c-0.7,0.4-1.4,0.4-1.9,0.1 c-0.4-0.3-0.6-0.8-0.6-1.5c0-1.5,1.1-3.4,2.4-4.2c0.5-0.3,1-0.4,1.4-0.3C446.3,777.2,446.7,777.8,446.7,778.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082344038905234786380000012036365683515334057_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8576,
    y1: 751.6976,
    x2: 391.4171,
    y2: 745.5324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9201,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082344038905234786380000012036365683515334057_)",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: " M445.6,777.2c0.6,0.1,1.1,0.7,1.1,1.7c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5c-0.7,0.4-1.4,0.4-1.9,0.1l-0.5-0.3 L333,719.6c-1.3-0.7,0-5.2,3.3-5.9l109.4,63.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.34
    },
    width: 146,
    height: 101,
    xlinkHref: "3627813872AD4D0D.png",
    transform: "matrix(1 0 0 1 314.6545 703.9762)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M446.7,778.8c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5c-0.7,0.4-1.4,0.4-1.9,0.1 c-0.4-0.3-0.6-0.8-0.6-1.5c0-1.5,1.1-3.4,2.4-4.2c0.5-0.3,1-0.4,1.4-0.3C446.3,777.2,446.7,777.8,446.7,778.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018940796942566403430000013425666954235696544_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8576,
    y1: 751.6976,
    x2: 391.4171,
    y2: 745.5324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4417,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6466,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7744,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9201,
    style: {
      stopColor: "#DADADA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018940796942566403430000013425666954235696544_)",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: " M445.6,777.2c0.6,0.1,1.1,0.7,1.1,1.7c0,0.9-0.4,1.9-0.9,2.7c-0.4,0.6-0.9,1.1-1.5,1.5c-0.7,0.4-1.4,0.4-1.9,0.1l-0.5-0.3 L333,719.6c-1.3-0.7,0-5.2,3.3-5.9l109.4,63.5"
  })))), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "350.8,722.1 354.5,720 364,725.4 363.9,729.6 "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.9,660.2l98.6-55.8c2.1-1.2,4.6-1.2,6.7,0l116.2,65.9c1,0.6,1,2,0,2.5l-100.5,57.9 c-0.8,0.5-1.8,0.5-2.6,0.1l0,0l-117-67.9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M552.3,671.1l0,4.4c0,0.8-0.4,1.6-1.2,2l-53.8,31.1l-46.6,26.8c-0.7,0.4-1.6,0.4-2.3,0l-117.5-68.1l-1.4-0.8 c-0.3-0.2-0.4-0.4-0.4-0.8v-4.1"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 449.2,
    y1: 765.4,
    x2: 449.2,
    y2: 739.1
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "449.6,879.3 449.6,893 449.7,910.1 "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M552.3,842c0,0.8-0.6,1.1-1.4,1.5l-6.5,3.9c-0.4,0.2-0.6,0.7-0.6,1.1l0,24.9c0,0.2-0.1,0.4-0.3,0.6l-87.4,50.4 c-0.3,0.2-0.7,0.2-1,0l-119.4-69.7c-0.4-0.3-0.7-0.7-0.7-1.3l0-6.1l-4.8-2.6c-0.7-0.4-1.2-1.1-1.2-2l0-33.3c0-0.4,0.2-0.7,0.5-1 l0.8-0.7l-0.5-0.3c-0.4-0.2-0.8-0.8-0.8-1.3l0-0.4l0-106.5c0-0.4,0.2-0.7,0.5-0.9l0.8-0.6l-0.4-0.2c-0.5-0.3-0.9-0.8-0.9-1.4l0-27.5 c0-0.1,0.1-0.2,0.2-0.3l1.7-1.1l-1.4-0.8c-0.3-0.2-0.4-0.4-0.4-0.8c0,0,0-4.4,0-4.8c0-0.4,0.3-0.6,0.7-0.8l98.6-55.8 c2.1-1.2,4.6-1.2,6.7,0l116.2,65.9c0,0,0.9,0.5,0.9,0.9"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 449.2,
    y1: 732.2,
    x2: 449.2,
    y2: 734.8
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "449.7,769.8 449.6,820 449.6,874.7 "
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 363.9,
    y1: 725.3,
    x2: 359.9,
    y2: 727.4
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "417.3,760.9 421,758.8 430.5,764.2 430.4,768.4 "
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 430.4,
    y1: 764.1,
    x2: 426.4,
    y2: 766.2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 449.2,
    cy: 730.9,
    r: 1.2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M431.5,736.5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M427.3,738.5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M377.6,853.6"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 195.7,
    y1: 786.3,
    x2: 344.7,
    y2: 787.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 195.7,
    y1: 786.3,
    x2: 344.7,
    y2: 787.1
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 195.7,
    y1: 786.3,
    x2: 344.7,
    y2: 787.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 195.7,
    y1: 786.3,
    x2: 344.7,
    y2: 787.1
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 190.8,
    cy: 788.4,
    r: 22.6
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 183.4454 797.1462)",
    className: "st1",
    style: {
      fontFamily: "'VAGRoundedStd-Bold'",
      fontSize: "28.0583px"
    }
  }, "B"), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 342.9,
    cy: 787,
    r: 4.3
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 196,
    y1: 716.5,
    x2: 336.9,
    y2: 717.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 196,
    y1: 716.5,
    x2: 336.9,
    y2: 717.5
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 196,
    y1: 716.5,
    x2: 335.1,
    y2: 717.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 196,
    y1: 716.5,
    x2: 335.1,
    y2: 717.2
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 191.1,
    cy: 718.6,
    r: 22.6
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 182.265 727.3837)",
    className: "st1",
    style: {
      fontFamily: "'VAGRoundedStd-Bold'",
      fontSize: "28.0583px"
    }
  }, "A"), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 336.9,
    cy: 717.5,
    r: 4.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.6a2912f8.svg";
export { ForwardRef as ReactComponent };